import cx from "classnames";

import {
  EmptystateArrowsLeftRightColored,
  EmptystateArrowsRightLeftColored,
} from "components/icons/generated";
import { HookType } from "utils/hooks";
import DropEmptyState from "components/DropEmptyState";

import styles from "./styles.module.css";

type BeforeAfterCommandsEmptyStateProps = {
  type: HookType;
  hidden: boolean;
  isDragActive: boolean;
};

const BeforeAfterCommandsEmptyState = ({
  type,
  hidden,
  isDragActive,
}: BeforeAfterCommandsEmptyStateProps) => {
  return (
    <DropEmptyState
      dropCaption="You can drop the command here"
      isDragActive={isDragActive && !hidden}
      icon={type === "before" ? EmptystateArrowsRightLeftColored : EmptystateArrowsLeftRightColored}
      caption={`This is where your ${type} commands will appear`}
      padding={hidden ? undefined : "large"}
      margin={hidden ? undefined : "0 0 large"}
      className={cx(styles.box, {
        [styles.hidden]: hidden,
      })}
    />
  );
};

export default BeforeAfterCommandsEmptyState;
